/*
  merchant page banner
*/
/**
 * Desktop Merchant Promo Banner Management
 */

 /************************************************
 		DISPLAY/HIDE DEPENDING IF HAVING CONTENT OR NOT
 *************************************************/
 var mctp_banner = $(".desk_hding_banner_line_cta-1"); // the banner
 var mctp_banner_content = mctp_banner.find(".wrapper > .container > .row > .col-md-12"); // the banner content

 //-- if no content found.. hide it
 if (mctp_banner_content.children().length < 1) {
   mctp_banner.remove();
 }
